import { storeToRefs } from 'pinia';
import { reviewExtendedStore } from '~/stores/reviewExtended';

import getSortParamsFromString from '~~/helpers/getSortParamsFromString';
import { DEFAULT_SORTING_OPTION } from '~~/constants/reviewSortingOptions';

export default function () {

  const store = reviewExtendedStore();
  const { sortParam } = storeToRefs(store);

  store.setSortParam(getSortParamsFromString(DEFAULT_SORTING_OPTION));

  return {
    ...store,
    sortParam,
  };

}